var React = require('react');

function IconShutdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M704.1 255.8H320.7c-141.2 0-255.6 114.4-255.6 255.6S179.5 767 320.7 767h383.5c141.1 0 255.5-114.4 255.5-255.6S845.3 255.8 704.1 255.8zm-340.8 426c-94.1 0-170.4-76.3-170.4-170.4S269.2 341 363.3 341s170.4 76.3 170.4 170.4-76.3 170.4-170.4 170.4z"}));
}

IconShutdown.displayName = "IconShutdown";

IconShutdown.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconShutdown;

IconShutdown.default = IconShutdown;
